/*! Copyright (c) Safe As Milk. All rights reserved. */
function tabClick(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("js-using-tab");
        window.removeEventListener("keydown", tabClick);
    }
}

window.addEventListener("keydown", tabClick);

window.theme ??= {};

window.theme.wrapRteTables = (rootElement = document) => {
    const wrapTable = (el, wrapper) => {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    };
    rootElement.querySelectorAll(".rte table").forEach((table => {
        if (table.closest(".js-theme-utility-rte-table-wrap")) return;
        const tableWrapper = document.createElement("div");
        tableWrapper.classList.add("js-theme-utility-rte-table-wrap");
        tableWrapper.setAttribute("style", "overflow:auto;-webkit-overflow-scrolling:touch");
        wrapTable(table, tableWrapper);
    }));
};

window.theme.wrapRteTables();

const scrollEndSupported = typeof window === "undefined" ? true : "onscrollend" in window;

if (!scrollEndSupported) {
    import("scrollyfills");
}

// SPINSTUDIO CUSTOM
(function() {
  function forceLoadScript(url) {
    var s = document.createElement('script');
    s.src = url + '?_=' + new Date().getTime();
    s.async = true;
    s.onload = function() {
      this.remove();
    };
    
    document.head.appendChild(s);
  }

  document.addEventListener('change', function(event) {
    if (event.target.closest('.product-form__swatch__item') || event.target.closest('.product-form__swatch__label')) {
      forceLoadScript('/tools/spinstudio/spinstudio.js');
    }
  }, true);

  document.addEventListener('click', function(event) {
    if (event.target.closest('.product-form__swatch__label') || event.target.closest('.product-form__swatch__item')) {
      forceLoadScript('/tools/spinstudio/spinstudio.js');
    }
  }, true);
})();
// SPINSTUDIO CUSTOM

//# sourceMappingURL=global.js.map
